import * as React from "react";
import Box from "@mui/material/Box";
import "./design.css";
import { useNavigate } from "react-router-dom";
import { Winning } from "../Model/Auction";

function MyFavorite() {
  const [dataWinnging, setGetWinning] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const getWinning = () => {
    setLoading(true);
    try {
      async function WinningLot() {
        const results = await Winning();
        // console.log(results.data)

        setLoading(false);
        setGetWinning(results.data);
      }
      WinningLot().catch((error) => {
        setLoading(false);
      });
    } catch (error) {}
  };

  React.useEffect(() => {
    getWinning();
  }, []);

  return (
    <Box
      style={{
        marginTop: 20,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(400px, 100%), 1fr))",
        gap: 3,
      }}
    >
      {dataWinnging.map((val, index) => {
        return (
          <div class="winning-lots-container" key={index}>
            <h4>{val.auction_name}</h4>
            <div class="lot-card">
              <div
                alt={index}
                style={{
                  backgroundImage: `url(${
                    val.img_url === null
                      ? "https://placehold.co/360x370?text=NO%20IMAGE%20AVAILABLE"
                      : val.img_url
                  })`,
                  backgroundColor: "#ffffff",
                  width: "100%",
                  height: 200,
                  display: "inline-block",
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
              {/* <img src={val.img_url} alt={index} /> */}
              <div class="lot-details">
                <h3>{val.title}</h3>
                <p class="artist">Artist: {val.artist}</p>
                <p class="price">Final Bid: ₱{val.hammer_price}</p>
                <p class="status won">Status: Won ✅</p>
              </div>
            </div>
          </div>
        );
      })}
    </Box>
  );
}

export default MyFavorite;
